class Transition {
	constructor () {
		this.timeline = null
		this.setup()
	}

	get shouldAnimate () { return true }

	animateIn () {
		if (this.shouldAnimate) {
			this.timeline.restart()
		}
	}

	animateOut () {
		if (this.shouldAnimate) {
			this.timeline.reverse()
		}
	}
}

export default Transition
